exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-total-summary[data-v-7f7c34fc],.total-shipping-summary[data-v-7f7c34fc]{margin-top:20px;font-weight:300;font-size:1.9rem;display:block}", ""]);

// exports
